import { Boxes, Loader2 } from 'lucide-react'

interface SellerPageLoaderProps {
  title?: string
  description?: string
  compact?: boolean
}

export function SellerPageLoader({
  title = 'Preparando seus dados',
  description = 'Organizando as informa\u00e7\u00f5es para exibir tudo com clareza.',
  compact = false,
}: SellerPageLoaderProps) {
  return (
    <div
      role='status'
      aria-live='polite'
      className={`relative isolate overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm ${compact ? 'min-h-[320px]' : 'min-h-[480px]'}`}
    >
      <div className='absolute inset-0 animate-pulse p-5 sm:p-7' aria-hidden='true'>
        <div className='mb-6 h-7 w-52 rounded-lg bg-slate-100' />
        <div className='grid grid-cols-2 gap-3 lg:grid-cols-4'>
          {[0, 1, 2, 3].map((item) => (
            <div key={item} className='h-20 rounded-xl bg-slate-100' />
          ))}
        </div>
        <div className='mt-6 overflow-hidden rounded-xl border border-slate-100'>
          {[0, 1, 2, 3, 4].map((item) => (
            <div key={item} className='flex items-center gap-4 border-b border-slate-100 p-4 last:border-0'>
              <div className='h-10 w-10 rounded-lg bg-slate-100' />
              <div className='h-3 flex-1 rounded bg-slate-100' />
              <div className='h-3 w-20 rounded bg-slate-100' />
            </div>
          ))}
        </div>
      </div>

      <div className='absolute inset-0 bg-white/70 backdrop-blur-[1px]' aria-hidden='true' />
      <div className='relative z-10 flex min-h-[inherit] items-center justify-center px-6 py-12 text-center'>
        <div className='max-w-sm'>
          <div className='relative mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-teal-500 to-blue-600 text-white shadow-lg shadow-teal-200/60'>
            <Boxes className='h-7 w-7' />
            <Loader2 className='absolute -inset-2 h-20 w-20 animate-spin text-teal-500/35' strokeWidth={1.5} />
          </div>
          <h2 className='text-base font-semibold text-slate-900'>{title}</h2>
          <p className='mt-1.5 text-sm leading-6 text-slate-500'>{description}</p>
          <div className='mx-auto mt-5 flex w-20 items-center gap-1.5' aria-hidden='true'>
            <span className='h-1.5 flex-1 animate-pulse rounded-full bg-teal-500' />
            <span className='h-1.5 flex-1 animate-pulse rounded-full bg-blue-400 [animation-delay:150ms]' />
            <span className='h-1.5 flex-1 animate-pulse rounded-full bg-indigo-300 [animation-delay:300ms]' />
          </div>
        </div>
      </div>
    </div>
  )
}
